import { SectionTitle } from '@/components/molecules'
import { PageContainer } from '@/components/organisms'
import InfoItem from '@/containers/OrderContainer/Common/InfoItem'

const Section = ({ id, title }) => {
  return <SectionTitle id={id} label={title} />
}

const DisplayInformation = ({orderDetails}) => (
  <>
    {/* Dates Section */}
    <div className="order-overview">
      <div className="sc-border grid  pl-4">
        <Section id="dates" title="Dates" />
      </div>
      <div className="grid grid-cols-3 gap-4 pb-6 pl-4">
        <InfoItem label="Order Date" value={orderDetails?.orderDate} />
        <InfoItem label="Expected Delivery Date" value={orderDetails?.expectedDeliveryDate} />
        <InfoItem label="Invoice Date" value={orderDetails?.invoiceDate} />
      </div>
      <div className="sc-border grid pl-4">
        <Section id="identification_details " title="Identification Details" />
      </div>
    </div>

    {/* Identification Details Section */}
    <div className="order-overview">
      <div className="grid grid-cols-3 gap-4 pb-6 pl-4">
        <InfoItem label="Order Type" value={orderDetails?.orderType} />
        <InfoItem
          label="Local Order ID"
          value={orderDetails?.localOrderId}
          icon={{name: 'info', alt: 'info', size: 'small'}}
          tooltip="Refers to Order ID generated in the local fulfilment system"
        />
        <InfoItem label="Customer PO Number" value={orderDetails?.customerPoNumber} />
        <InfoItem label="Category" value={orderDetails?.category} />
        <InfoItem label="Cart ID" value={orderDetails?.cartId} />
        <InfoItem label="Reference Invoice ID" value={orderDetails?.referenceInvoiceId} />
        <InfoItem label="Warehouse ID" value={orderDetails?.warehouseId} />
      </div>
      <div className="grid pl-4">
        <InfoItem label="Customer Remark" value={orderDetails?.customerRemark} />
      </div>
      <div className="sc-border grid pl-4">
        <Section id="order_status_and_details" title="Order Status and Details" />
      </div>
    </div>

    {/* Order Processing and Details Section */}
    <div className="order-overview  pl-4">
      <div className="grid grid-cols-3 gap-4 pb-6">
        <InfoItem label="Route ID" value={orderDetails?.routeId} />
        <InfoItem label="Route Type ID" value={orderDetails?.routeTypeId} />
        <InfoItem label="Route Sales Rep WorkForce ID" value={orderDetails?.routeSalesRepWorkForceId} />
      </div>
      <InfoItem label="Points Returned" value={orderDetails?.pointsReturned} />
      <InfoItem label="Reject Reason" value={orderDetails?.rejectReason} />
      <InfoItem label="Template Cancellation Reason" value={orderDetails?.templateCancellationReason} />
    </div>
  </>
)

const OrderInfo = ({ OrderDetails }) => {
  return (
    <PageContainer>
      <DisplayInformation orderDetails={OrderDetails} />
    </PageContainer>
  )
}

export default OrderInfo